module.exports = __webpack_public_path__ + "img/Vehicle-3.5a9d3f4a.png";